// Get the App Page (Web Only) - /getapp
// A standalone, shareable version of the first-visit app-download prompt.
// Unlike MobileAppPromptModal (which only appears on mobile browsers), this
// page renders on any browser so the link can be shared with anyone.

import React from 'react';
import { View, StyleSheet, Platform, ScrollView } from 'react-native';
import AppDownloadPanel from '../../components/web/AppDownloadPanel';

const GetAppScreen = () => {
  if (Platform.OS !== 'web') {
    return null;
  }

  return (
    <View style={styles.root}>
      <ScrollView
        contentContainerStyle={styles.scrollContent}
        showsVerticalScrollIndicator={false}
      >
        <AppDownloadPanel />
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: '#ffffff',
    minHeight: '100vh',
  },
  scrollContent: {
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
  },
});

export default GetAppScreen;
